const VENUE_RECORD_CACHE_TTL_MS = 10 * 60 * 1000;
const venueRecordCache = new Map();

export const getCachedVenueRecord = (venueId) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key) return null;
  const entry = venueRecordCache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > VENUE_RECORD_CACHE_TTL_MS) {
    venueRecordCache.delete(key);
    return null;
  }
  return entry.data;
};

export const setCachedVenueRecord = (venueId, data) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key || data == null) return;
  venueRecordCache.set(key, { data, fetchedAt: Date.now() });
};

export const clearVenueRecordCache = (venueId) => {
  if (venueId != null) {
    venueRecordCache.delete(String(venueId));
    return;
  }
  venueRecordCache.clear();
};

export const fetchVenueRecordCached = async (venueId, fetcher, { forceRefresh = false } = {}) => {
  if (!forceRefresh) {
    const cached = getCachedVenueRecord(venueId);
    if (cached) return cached;
  }
  const data = await fetcher(venueId);
  setCachedVenueRecord(venueId, data);
  return data;
};
